<div class="your-order-info">
  <table class="info-block-table receipt-order-table simplify-order-table">
    <thead>
    <tr>
      <th class="info-block-table-th font-xxxs" [translate]="'receipt.product'"></th>
      <th class="info-block-table-th font-xxxs text-center px-2" [translate]="'receipt.quantity'"></th>
    </tr>
    </thead>

    @for (orderLine of order.orderLines; track orderLine.id) {
      @if (orderLine.type !== ORDER_LINE_STATES.DELETED) {
        @if (orderLine.type !== CART_LINE_TYPES.INVOICE_FEE && orderLine.type !== CART_LINE_TYPES.REFUND) {
          <tbody
            class="font-md order-line"
            product-tbody
            [orderLine]="orderLine"
            [simplifyView]="true"
          ></tbody>
        }

        @for (subOrderLine of orderLine.orderLines; track subOrderLine.trackId || subOrderLine.id) {
          @if (subOrderLine.type === CART_LINE_TYPES.GROUPED_EXTRA_PRODUCTS) {
            <tbody
              class="font-md"
              grouped-extra-product-tbody
              [orderLine]="subOrderLine"
              [simplifyView]="true"
            ></tbody>
          }

          @if (subOrderLine.type !== CART_LINE_TYPES.GROUPED_EXTRA_PRODUCTS && subOrderLine.state !== ORDER_LINE_STATES.DELETED) {
            <tbody
              class="font-md"
              extra-product-tbody
              [orderLine]="subOrderLine"
              [simplifyView]="true"
            ></tbody>
          }
        }
      }
    }
  </table>
</div>
